module.exports = __webpack_public_path__ + "04_bob_grey.5a760326.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/04_bob_grey.png
// module id = keVG
// module chunks = 0